import {
    ListarUsuariosNaoVincladoPorEquipeService,
    ListarUsuariosVincladoPorEquipeService,
    VincularUsuarioEquipeService,
    DesvincularUsuarioEquipeService,
} from "../../../Services/HelpDesk/Equipes/EquipeUsuarioServices";

import { IEquipeUsuario } from "../../../Interfaces/HelpDesk/Equipes/EquipeInterface";
import { Controller } from "../../Controller";

export async function ListarUsuariosVincladoPorEquipeController(
    ID_FILA: number
) {
    return Controller(ListarUsuariosVincladoPorEquipeService(ID_FILA));
}

export async function ListarUsuariosNaoVincladoPorEquipeController(
    ID_FILA: number
) {
    return Controller(ListarUsuariosNaoVincladoPorEquipeService(ID_FILA));
}

export async function VincularUsuarioEquipeController(
    requestBody: IEquipeUsuario
) {
    return Controller(VincularUsuarioEquipeService(requestBody));
}

export async function DesvincularUsuarioEquipeController(
    requestBody: IEquipeUsuario
) {
    return Controller(DesvincularUsuarioEquipeService(requestBody));
}
